export default {
    badge: "знак",
    close: "Закрыть",
    dataIterator: {
        noResultsText: "Не найдено подходящих записей",
        loadingText: "Запись загружается..."
    },
    dataTable: {
        itemsPerPageText: "Строк на странице:",
        ariaLabel: {
            sortDescending: "Упорядочено по убыванию.",
            sortAscending: "Упорядочено по возрастанию.",
            sortNone: "Не упорядочено.",
            activateNone: "Активируйте, чтобы убрать сортировку.",
            activateDescending: "Активируйте для упорядочивания убыванию.",
            activateAscending: "Активируйте для упорядочивания по возрастанию.",
        },
        sortBy: "Сортировать по",
    },
    dataFooter: {
        itemsPerPageText: "Записей на странице:",
        itemsPerPageAll: "Все",
        nextPage: "Следующая страница",
        prevPage: "Предыдущая страница",
        firstPage: "Первая страница",
        lastPage: "Последняя страница",
        pageText: "{0}-{1} из {2}"
    },
    datePicker: {
        itemsSelected: "{0} выбран",
        nextMonthAriaLabel: "Следующий месяц",
        nextYearAriaLabel: "Следующий год",
        prevMonthAriaLabel: "Прошлый месяц",
        prevYearAriaLabel: "Предыдущий год"
    },
    noDataText: "Отсутствуют данные",
    carousel: {
        prev: "Предыдущий слайд",
        next: "Следующий слайд",
        ariaLabel: {
            delimiter: "Слайд {0} из {1}"
        }
    },
    calendar: {
        moreEvents: "Еще {0}"
    },
    fileInput: {
        counter: "Файлов: {0}",
        counterSize: "Файлов: {0} (всего {1})"
    },
    timePicker: {
        am: "AM",
        pm: "PM"
    },
    pagination: {
        ariaLabel: {
            wrapper: "Навигация по страницам",
            next: "Следующая страница",
            previous: "Предыдущая страница",
            page: "Перейти на страницу {0}",
            currentPage: "Текущая страница, Страница {0}"
        }
    },
    rating: {
        ariaLabel: {
            icon: "Рейтинг {0} из {1}"
        }
    },

    start: "Начало",
    deadline: "Дедлайн",
    sure: "Вы уверены",
    sureArchive: "Подтвердите архивацию",
    sureOutArchive: "Подтвердите разархивацию",
    yes: "да",
    value: "Значение",
    addNew: "Добавить новость",
    uploadNewsImage: "Загрузить обложку (jpg, png)",
    publish: "Опубликовать",
    title: "Заголовок",
    addEvent: "Добавить событие",
    today: "Сегодня",
    month: "Месяц",
    day: "День",
    addingEvent: "Добавление события",
    editingEvent: "Редактирование события",
    deletingEvent: "Удаление события",
    time: "Время",
    endDate: "Дата окончания",
    allDay: "Весь день",
    period: "Сроки",
    confirmDeleteEvent: "Вы действительно хотите удалить выбранное событие? Отменить это действие будет невозможно",
    forWhomRule: "Выберите для кого событие",
    forWhom: "Для кого",
    forSelf: "Для себя",
    forGroup: "Для группы",
    forAll: "Для всех",
    forUser: "Для пользователя",
    description: "Описание",
    confirm: "Подтвердить",
    aboutObject: "Об объекте",
    worksEnd: "Дата окончания работ",
    worksEndLate: "Дата окончания работ c учетом опоздания",
    worksStart: "Дата начала работ",
    objectName: "Название объекта",
    square: "Метраж",
    accidentInsurance: "Страховка несчастных случаев",
    healthInsurance: "Страховка здоровья",
    habitation: "жильё",
    number: "Номер",
    name2: "Название",
    shortName: "Короткое название",
    position: "Должность",
    name: "Имя",
    surname: "Фамилия",
    no: "нет",
    have: "есть",
    phone: "Телефон",
    email: "E-mail",
    ogrn: "Регистрационный номер",
    address: "Адрес",
    staff: "Штат сотрудников",
    documents: "Документы",
    planning: "Планируются",
    inProgress: "В процессе",
    finished: "Завершены",
    back: "Назад",
    cancel: "Отменить",
    forward: "Далее",
    documentName: "Название документа",
    documentType: "Тип документа",
    dateDownload: "Дата загрузки",
    objectNumber: "Номер объекта",
    objectAddress: "Адрес объекта",
    client: "Клиент",
    clientPhone: "Телефон клиента",
    clientEmail: "Почта клиента",
    employesOnObject: "Рабочие на объекте",
    workList: "Список работ",
    comments: "Комментарии",
    comment: "Комментарий",
    news: "Новости",
    readAlso: "Читать также",
    save: "Сохранить",
    addCard: "Добавить карту",
    addWork: "Добавить работу",
    addEmployee: "Добавить работника",
    addObject: "Добавить объект",
    editObject: "Редактировать объект",
    addContact: "Добавить контакт",
    editContact: "Редактировать контакт",
    addGroup: "Добавить группу",
    editGroup: "Редактировать группу",
    addTimeReport: "Новый отчет",
    editTimeReport: "Редактировать отчет",
    addClient: "Добавить клиента",
    addDocument: "Добавить документ",
    add: "Добавить",
    changePhoto: "Сменить фото",
    changeSignature: "Сменить подпись",
    changeDocument: "Сменить документ",
    bankAccount: "Банковский счет",
    systemRole: "Роль в системе",
    aboutEmployee: "О работнике",
    cards: "Карты и пропуска",
    skills: "Навыки",
    roof: "Установка крыши",
    floor: "Укладка пола",
    personalInfo: "Личная информация",
    citizenship: "Гражданство",
    birthday: "День рождения",
    addressOwn: "Адрес проживания в родной стране",
    addressFin: "Адрес проживания в Финляндии",
    otherPhone: "Дополнительный телефон",
    additional: "Дополнительно",
    driverLicense: "Водительские права",
    driverLicenseCat: "Водительские права категории",
    ownCar: "Личный автомобиль",
    ownTools: "Свой инструмент",
    haveOwnCar: "Есть свой автомобиль",
    haveOwnTools: "Есть свой инструмент",
    languages: "Владение языками",
    uniform: "Рабочая форма",
    editPersonal: "Редактирование личной информации",
    editAdditional: "Редактирование дополнительной информации",
    fromFinland: "Я из Финляндии",
    fromAnotherCountry: "Я из другой страны",
    socialCodeFin: "Финский henkilotunnus",
    taxNumber: "Veronumero",
    street: "Улица",
    house: "Дом",
    flat: "Квартира",
    entrance: "Подъезд",
    index: "Индекс",
    city: "Город",
    country: "Страна",
    sizeUniform: "Размер рабочей формы",
    size: "Размер",
    shirt: "Футболка",
    pants: "Брюки",
    jacket: "Куртка",
    boots: "Сапоги",
    gloves: "Перчатки",
    cardNumber: "Номер документа",
    dueDate: "Срок действия",
    uploadImg: "Загрузить изображение (jpg, png)",
    changeImg: "Изменить фото (jpg, png)",
    deleteCard: "Удалить карту",
    paintingWorks: "Малярные работы",
    outdoor: "Наружные",
    indoor: "В помещении",
    plastering: "Штукатурные работы",
    manual: "Ручные",
    hardware: "Аппаратные",
    facade_plasteir: "Фасадная штукатурка",
    chain: "С рабицей",
    plasterboard: "С пластсеткой",
    alignment: "Выравнивание",
    carpentry: "Плотницкие работы",
    simple: "Обычные",
    formwork: "С опалубкой",
    suspendedCeilings: "Подвесные потолки",
    giprok: "Гипрок",
    panels: "Панели",
    partitionWalls: "Перегородочные стены",
    tileWaterproofing: "Кафельная плитка + гидроизоляция",
    Floor: "Укладка пола",
    parquet: "Паркет",
    laminate: "Ламинат",
    masonry: "Кладка камня и кирпича",
    concrete_works: "Бетонные работы",
    reinforcement: "Армирование",
    tiles: "Черепица",
    metal: "Металл",
    bitumen: "Битумные работы",
    bitumen_roof: "Крыша",
    bitumen_plinth: "Цоколь",
    welding: "Сварка",
    diamondCuttingDrilling: "Алмазная резка и бурение",
    fillForm: "Заполните все обязательные поля",
    addDocumentRule: "Прикрепите документ",
    required: "Обязательное поле",
    enterText: "Введите ваше сообщение",
    enterWorkText: "Введите название работы",
    lettersOnly: "Введите только буквенные символы",
    incorrectEmail: "Некорректный E-mail",
    companyName: "Название компании",
    activityType: "Род деятельности",
    regNumber: "Рег. номер",
    website: "Вебсайт",
    logo: "Логотип",
    editClient: "Редактировать клиента",
    edit: "Редактировать",
    delete: "Удалить",
    surnameName: "Фамилия, имя",
    speciality: "Специальность",
    company: "Компания",
    mainInfo: "Основная информация",
    downloadDocument: "Загрузить документ (pdf, doc, docx, jpg)",
    downloadPhoto: "Загрузить фото (jpg, png)",
    date: "Дата",
    workType: "Сделанные работы",
    selectObjectLabel: "Объект",
    selectWorker: "Выберите работника",
    selectClient: "Выберите клиента",
    selectContact: "Выберите контакт",
    wages: {
        label: "Тип оплаты",
        piecework: "Сдельная",
        hourly: "Почасовая",
        fixed: "Фиксированная ставка",
        sum: "Оплата",
        rate: "Ставка",
        quantity: "Количество",
        measurement: "Ед",
        hours: "Часов",
        time: "Время (ч)"
    },
    measurements: {
        kg: "кг",
        g: "г",
        m: "м",
        m2: "м2",
        m3: "м3",
        pc: "шт",
        rll: "рул"
    },
    typeBody: "Тип кузова",
    vin: "VIN номер",
    regData: "Регистрационные данные",
    carView: "Внешний вид",
    carTechnic: "Технические характеристики",
    carDocuments: "Документы на автомобиль",
    regDate: "Дата регистрации",
    odometer: "Одометр (км)",
    engine: "Двигатель",
    fuel: "Топливо",
    typeDrive: "Привод",
    transmission: "Коробка передач",
    color: "Цвет",
    characteristics: 'Характеристики',
    sorts: {
        sortBy: "Сортировать по",
        search: "Поиск",
        searchMan: "Поиск по имени, телефону или e-mail",
        searchWorker: "Поиск по имени работника",
        searchObject: "Поиск по названию, номеру или адресу",
        searchCar: "Поиск по названию, номеру или vin",
        searchName: "Поиск по названию, номеру",
        searchWaybills: "Поиск по адресам",
        searchContracts: "Поиск по названию документа",
        searchDocuments: "Поиск по названию документа",
        byObjects: "объекту",
        byWorkType: "виду работы",
        bySum: "оплате",
        byTotalSum: "сумме",
        byDate: "дате",
        byCreateDate: "дате добавления",
        byStartDate: "дате начала",
        byRegDate: "дате регистрации",
        byCategory: "категории",
        byAccountant: "имени бухгалтера",
        byBank: "банку",
        byName: "названию",
        bySubject: "субъекту",
        byClient: "клиенту",
        byStatus: "статусу",
        byAddress: "адресу",
        byCost: "стоимости",
        byCar: "автомобилю",
        byFullName: "имени",
        byWorkerPosition: "специальности",
        byContactPosition: "должности",
        byMileage: "километражу",
        byNumber: "номеру",
        byBranch: "роду деятельности",
        byCompany: "компании",
        byType: "типу документа",

        byPhone: "телефону",
        byEmail: "email",
        byRegNumber: "регистрационному номеру",
    },
    menu: {
        'holidays': 'Выходные',

        charts: 'Диаграммы',
        main: "Главная",
        news: "Новости",
        "news-item": "Новость",
        "news-add": "Добавить новость",
        "news-edit": "Редактировать новость",
        workers: "Работники",
        "workers-item": "Работник",
        "worker-timings": "Часовые отчеты работника",
        clients: "Записная книжка",
        "clients-item": "Клиент",
        partners: "Партнеры",
        contacts: "Контакты",
        objects: "Объекты",
        "objects-item": "Объект",
        "object-timings": "Часовые отчеты по объекту",
        calendar: "Календарь",
        faq: "Поддержка",
        timings: "Отчетность",
        accounting: "Бухгалтерия",
        settings: "Настройки",
        "settings-item": "Настройки",
        waybills: "Путевые листы",
        addWaybill: "Добавить путевой лист",
        BookkeepingView: "Бухгалтерия",
        documents: "Документы",
        'documents-absence': "Отсутствие",
        'documents-timings': "Отчетность",
        addBookkeeping: "Добавить документ",
        garage: "Гараж",
        "garage-item": "Гараж",
        profile: "Профиль",
        "companyProfile": "Профиль компании",
        'clients-profile': "Профиль",
        groups: "Группы",
        AuthLayout: "Авторизация",
        ResetPassword: "Сброс пароля",
        SignUpLayout: "Регистрация",
        SignUpTenantLayout: "Регистрация",
        404: "Не найдено",
        useful: "Полезное",
        absence: "Отсутствие",
        TechnicalWorks: "Технические работы",
        todo: "ToDo List",
        "todo-object": "ToDo List",
        catalog: "Каталог",
        addOrder: "Добавить заказ",
        editOrder: "Редактировать заказ",
        businessCards: "Визитки",
        tenants: "Арендаторы",
        tariffPlans: "Тарифные планы",
        organizations: "Организации",
        company: "Данные компании",
        SuccessLayout: "Оплата прошла упешно",
        ErrorLayout: "Ошибка оплаты",
        safe: "Сейф",
        notifications: "Оповещения",
        SelectCompany: "Выберите компанию",
        timingChangesList: "Изменения часовых отчетов",
        'reports': "Бухгалтерские отчеты",
        'extracts': 'Банковские выписки',
        'contracts': 'Договоры',
        'property': 'Недвижимость',
        'purchases': 'Расходы',
        'sales': 'Доходы',
        'offers': 'Ценовые предложения',
        "languages": "Языки",
        PrivacyPolicy: "Политика конфиденциальности",
        DeleteAccount: "Удаление аккаунта",
        "personal": "Личное",
        "work": "Работа",
        "resources": "Ресурсы",
        "another": "Другое",
        "system": "Системное",
        "about": "О компании",
        "invitePartner": "Пригласить подрядчика",
        "hh": "Поиск работы",
        "CVs": "Поиск работников",
        "CV": "Резюме",
        "MyVacancies": "Мои вакансии",
        "OrganizationResponds": "Отклики организации",
        "Vacancies": "Вакансии",
        "Vacancy": "Вакансия",
        "MyResponds": "Мои отклики",
        "MyRespond": "Мой отклик",
        "Responds": "Отклики",
        "Respond": "Отклик",
        "FindOrganizations": "Поиск компаний",
        "hr": "Найм",
        "PersonalTasks": "Список задач",
        "lists": "Списки",
    },
    goto: "Перейти в раздел",
    gotoProfile: "Перейти в профиль",
    archive: "Архив",
    outArchive: "Выйти из архива",
    toArchive: "Архивировать",
    deleteArchive: "Удалить из архива",
    printDoc: "Распечатать анкету",
    loadDoc: "Скачать документ",
    main: {
        see_all: "Смотреть все",
        profile: {
            label: "Профиль"
        },
        news: {
            label: "Новости"
        },
        calendar: {
            label: "Ближайшие события"
        }
    },
    widgets: {
        h1Label: "Виджеты",
        new: "Новый виджет",
        selectWidget: "Выберите виджет",
        note: {
            label: "Блокнот",
            lastSave: "Последнее сохранение",
        },
    },
    workers: {
        skills: {
            outdoor_painting: "Наружные малярные работы",
            indoor_painting: "Малярные работы в помещении",
            manual_plastering: "Ручные штукатурные работы",
            hardware_plastering: "Аппаратные штукатурные работы",
            facade_plasteir_chain: "Фасадная штукатурка с рабицей",
            facade_plasteir_plasterboard: "Фасадная штукатурка с пластсеткой",
            alignment: "Выравнивание",
            carpentry_simple: "Плотницкие работы",
            carpentry_formwork: "Плотницкие работы с опалубкой",
            suspended_ceilings_giprok: "Подвесные потолки (гипрок)",
            suspended_ceilings_panels: "Подвесные потолки (панели)",
            partition_walls: "Перегородочные стены",
            tile_waterproofing: "Кафельная плитка + гидроизоляция",
            floor_parquet: "Укладка паркета",
            floor_laminate: "Укладка ламината",
            masonry: "Кладка камня и кирпича",
            concrete_works: "Бетонные работы",
            concrete_installation: "Установка бетонных элементов",
            reinforcement: "Армирование",
            roof_tiles: "Установка крыши (черепица)",
            roof_metal: "Установка крыши (металл)",
            bitumen_roof: "Битумные работы (крыша)",
            bitumen_plinth: "Битумные работы (цоколь)",
            welding: "Сварка",
            diamond_cutting_drilling: "Алмазная резка и бурение",
            control_loader: "Управление погрузчик",
            control_lift: "Управление подъемником",
            control_tractor: "Управление трактором",
            control_transport: "Управление спецтранспортом",
            loader: "Погрузчик",
            lift: "Подъемник",
            linoleum: "Линолеум",
            epoxy_coating: "Эпоксидное покрытие",
            electrics: "Электрика",
            plumbing: "Сантехнические работы",
            sandblasting: "Пескоструйные работы",
            dismantling: "Демонтаж/разлом",
            asbestos: "Асбестовые работы",
            cleaning: "Уборка",
        }
    },
    timings: {
        add: "Добавить отчет",
        tabs: {
            piecework: "Сдельная оплата",
            hourly: "Почасовая оплата",
            fixed: "Оклад",
        }
    },
    statistic: "Статистика",
    accounting: {
        card: {
            scan: "Скан",
            worker: "Работник",
            category: "Категория",
            period: "Период",
            bank: "Банк",
            date: "Дата",
            datecontracts: "Дата заключения",
            datedocuments: "Дата подписания",
            dateproperty: "Дата подписания",
            datepurchases: "Дата оплаты",
            dategarage: "Дата ремонта",
            dateCreate: "Дата выдачи",
            dateReceipt: "Дата получения",
            dateRemind: "Дата напоминания",
            dateDelivery: "Дата доставки",
            dueDate: "Действительно до",
            subject: "Субъект",
            concluded: "Заключен с",
            name: "Название",
            contractName: "Название договора",
            documentName: "Название документа",
            author: "Бухгалтер",
            status: "Статус",
            percentDelay: "Процент по просрочке",
            statusPayed: "Оплачен",
            statusCreated: "Выставлен",
            statusExpired: "Просрочен",
            cost: "Стоимость",
            address: "Адрес",
            sum: "Сумма",
            place: "Место",
            tax: "НДС",
            paymentMethod: "Способ оплаты",
            bankCard: "Банковская карта",
            bankTransfer: "Банковский перевод",
            cash: "Наличные",
            client: "Заказчик",
            object: "Объект",
            numberLink: "Ссылочный номер",
            id: "Номер",
            number: "Номер заказа",
            description: "Пояснение к счету",
            comment: "Заметки",
            term: "Срок",
            addService: "Добавить услугу",
            price: "Цена",
            discount: "Скидка(%)",
            type: "Товар/услуга",
            typeMaterial: "Товар",
            typeService: "Услуга",
            date_start: "Дата начала поездки",
            date_end: "Дата конца поездки",
            time_start: "Начало работы",
            time_end: "Окончание работы",
            way_time: "Время пути",
            mileage: "Километраж",
            mileageStart: "Км в начале",
            mileageEnd: "Км в конце",
            mileageTotal: "Длина в км",
            departure: "Пункт отправления",
            destination: "Пункт назначения",
            auto: "Регистрационный номер авто",
            goal: "Цель поездки",
            material: "материалы, все крепежи и расходники",
            delivery: "доставка материала со склада или магазина на объект",
            tool: "инструмент",
            lifts: "подъемники",
            scaffolding: "леса",
            montage_scaffolding: "монтаж и демонтаж лесов",
            garbage: "вывоз и утилизация мусора",
            garbage_containers: "мусорные контейнеры",
            security: "охрана объекта",
            social_room: "социальные помещения с водой, возможностью переодеваться и поесть, туалет",
            unloading: "разгрузка материала",
            spreading: "разнос материала по объекту",
            cleaning: "уборка на объекте",
            numberBill: "Номер счета",
            bundle: "Набор чеков",
            bundleSingle: "Один чек",
            bundleMultiple: "2 и более",
            car: "Авто"
        },
        statistic: {
            count: "Всего",
            categories: "Категорий",
            byCategory: "По категориям",
            perMonth: "Счетов за месяц",
            clients: "Клиентов",
            sum: "Сумма без налога",
            sumTax: "Сумма с налогом"
        },
        reports: {
            label: "Бухгалтерские отчеты",
            new: "Новый бухгалтерский отчет",
            scan: "Скан отчета",
            info: "Информация об отчете",
        },
        extracts: {
            label: "Банковские выписки",
            new: "Новая банковская выписка",
            scan: "Скан выписки",
            info: "Информация о выписке",
        },
        contracts: {
            label: "Договоры",
            new: "Новый договор",
            scan: "Скан договора",
            info: "Информация о договоре",
        },
        documents: {
            label: "Документы",
            new: "Новый документ",
            scan: "Скан документа",
            info: "Информация о документе",
        },
        property: {
            label: "Недвижимость",
            new: "Новый документ о недвижимости",
            scan: "Скан документа",
            info: "Информация о документе",
        },
        purchases: {
            label: "Расходы",
            new: "Новый чек",
            scan: "Скан чека",
            info: "Информация о чеке",
        },
        sales: {
            label: "Доходы",
            new: "Новый счет-фактура",
            scan: "Счет",
            number: "Номер счета-фактуры"
        },
        offers: {
            label: "Ценовые предложения",
            new: "Новое ценовое предложение",
            scan: "Скан ценового предложения",
            number: "Номер ценового предложения"
        },
        waybills: {
            label: "Путевые листы",
            new: "Новый путевой лист",
            scan: "Скан документа",
            info: "Информация о путевом листе",
        },
        garage: {
            label: "Ремонт авто",
            new: "Новый документ",
            scan: "Скан документа",
            info: "Информация о ремонте",
        },
        details: "Детали",
        serviceList: "Список услуг",
        newService: "Новая услуга",
        totalWithoutTax: "Итого без НДС",
        total: "Итого",
        fromClient: "От заказчика"
    },
    account: "Личный кабинет",
    auth: "Авторизация",
    registration: "Регистрация",
    password: "Пароль",
    forget: "Забыли пароль?",
    enter: "Войти",
    create: "Создать аккаунт",
    stayIn: "Оставаться в системе",
    logout: "Выйти из аккаунта",
    other: "Другие",
    passport: "Паспорт",
    residence: "Вид на жительство",
    signup: {
        cancel: "Отменить регистрацию",
        hello: "Здравствуйте! Для работы с этой платформой пожалуйста оставьте ваши данные",
        name: "Ваше имя",
        lastname: "Ваша фамилия",
        wantTitle: "Хотите у нас работать?",
        wantSubtitle: " Пожалуйста, заполните анкету. У вас уйдет на нее всего лишь 15 минут. Ваши данные нужны исключительно для трудоустройства и вашего удобства на работе. Посторонним они будут недоступны",
        birthdate: "Дата рождения",
        bankAccount: "Номер банковского счета",
        whereTitle: "Где вы живете?",
        whereSubtitle: "Ваш адрес нам нужен, чтобы мы могли вас зарегистрировать и отправлять вам письма от компании",
        addressFin: "Финский адрес",
        addressFromFin: "Так как вы из Финляндии, достаточно ввести ваш финский адрес",
        addressOwn: "Адрес в родной стране",
        additionalTitle: "Немного дополнительной информации",
        additionalSubtitle: "Эта информация нам тоже нужна, потому что здесь будет написана причина, почему она нужна",
        skillsTitle: "Оцените свои навыки",
        skillsSubtitle: "Так вы будете получать только те проекты, с которыми сможете справиться легко и качественно",
        mainSpec: "Ваша основная специальность",
        selectSpec: "Выберите специальность из списка",
        almostTitle: "Почти всё...",
        almostSubtitle: "Загрузите перечисленные документы для допуска на работу",
        photo: "Ваша фотография",
        photoSubtitle: "Убедитесь, что ваше лицо хорошо видно и вы смотрите в камеру. Лучше, если фотография будет, как для паспорта",
        residenceSubtitle: "Для иностранцев это обязательный документ",
        cardsTitle: "Остались только карточки",
        cardsSubtitle: " Выберите все карты, которые у вас есть. Наличие налоговой карты обязательно! Если каких-то карт из списка не хватает, вы сможете загрузить их позже при редактировании аккаунта",
        congratTitle: "Поздравляем!",
        congratSubtitle: "Ваш аккаунт успешно создан. В режиме редактирования аккаунта вы сможете внести оставшиеся данные или исправить имеющиеся. Можете начинать работу с платформой!",
        congratRentSubtitle: "Ваша анкета принята. Мы свяжемся с вами в течение 7 дней, чтобы обсудить детали аренды платформы. Также у вас начнется 14-дневный пробный период",
        wantRentTitle: "Хотите арендовать платформу?",
        wantRentSubtitle: "Для этого заполните анкету о вашей фирме, чтоб сделать платформу наиболее удобной для вашей деятельности. Заполнение анкеты займет примерно 5 минут",
        contactInfoTitle: "Контактные данные",
        contactInfoSubtitle: "Как мы можем с вами связаться?",
        detailsSubtitle: "Для формирования счета на оплату",
    },

    //для старой версии
    Index: {
        h1Label: "Главная",
        hello: "Добро пожаловать, ",
        todayLabel: "На сегодня",
        statistics: {
            news: {
                label: "Новости: ",
                text: "новостей"
            },
            workers: {
                label: "Работники: ",
                all: "работников",
                new: "Новых на сегодня",
                text: "Работает: ",
            },
            clients: {
                label: "Клиенты: ",
                all: "клиентов",
                new: "Новых на сегодня",
            },
            objects: {
                label: "Объекты: ",
                all: "обектов",
                text: "В работе",
            },
            calendar: {
                label: "Календарь: ",
                all: "событий",
                week: "На этой неделе",
                today: "Сегодня",
            },
        },
    },
    settings: {
        'holidays': 'Выходные',

        'workTypes': 'Типы работ',
        'language-settings': 'Языки',

        selectThemeLabel: "Выбор темы",
        selectLangLabel: "Язык интерфейса",
        languages: {
            rus: "Русский",
            eng: "Английский",
            fin: "Финский",
            est: "Эстонский",
            ukr: "Украинский",
            swe: "Шведский",
        },
        groups: "Управление группами пользователей",
        workerPosition: "Специальности работников",
        contactPosition: "Должности контактов",
        chequeCategories: "Категории чеков",
        reportsCategories: "Категории бухгалтерских отчетов",
        goals: "Цели поездок",
        banks: "Банки",
        terms: "Сроки",
        tax: "Налог",
        cards: "Карточки",
        read: "Чтение",
        edit: "Редактирование",
        absenceReasons: "Причина отсутствия",
        skills: "Навыки",
        companyData: "Данные компании",
        tripTime: "Время поездки для отчетности",
    },

    invalid_credentials: "Неверные email или пароль. Проверьте введенные данные",
    recoveryPassword: "Восстановление пароля",
    repeatPassword: "Повторите пароль",
    emailNotification: "На почту отправлена ссылка для восстановления пароля",
    recoveryButton: "Восстановить пароль",
    samePasswordRule: "Пароли не совдают",
    min8Rule: "Минимум 8 символов",
    notFound: "Страница не найдена",
    notFoundSubtitle: "Кажется, вы перешли по несуществующей ссылке или ввели неверный адрес",
    goMain: "Перейти на главную",
    editingComment: "Редактирование комментария",
    pause: "Пауза",
    minutes: "мин",
    hour: "ч",
    hours: "Часов",
    sortDescending: "по убыванию",
    sortAscending: "по возрастанию",
    perPage: "На странице",
    details: "Реквизиты",
    addDetails: "Добавить реквизиты",
    editDetails: "Редактировать реквизиты",
    selectType: "Выберите тип",
    "e-account": "Электронный счет",
    detailAddress: "Адрес для эл. счетов",
    operator: "Оператор",
    operator_id: "Идентификатор оператора",
    invoice_address: "Email счета-фактуры",
    client_name: "Имя клиента",
    bank: "Банк",
    bic: "BIC",
    iban: "IBAN",
    addLink: "Добавить ссылку",
    editLink: "Редактировать ссылку",
    addCategory: "Добавить категорию",
    link: "Ссылка",
    newComments: "Новые комментарии",
    notFoundAnswer: "Не нашли ответа на свой вопрос?",
    text: "Текст",
    reason: "Причина отсутствия",
    showQua: "Отображать в анкете",

    technical: "На сайте ведутся технические работы. Пожалуйста, зайдите позже",
    technicalTime: "Работы будут длиться с 13 до 23",
    error500: "Внутренняя ошибка сервера",
    selectShownHeaders: "Выбор отображаемых полей",
    preview: "Предпросмотр",
    payment: "Платеж",
    sendToEmail: "Отправить на email",
    send: "Отправить",
    simpleReg: "Короткая регистрация",
    history: "История изменений",
    author: "Автор",
    beforeChanges: "До изменений",
    afterChanges: "После изменений",
    answer: "Ответ на комментарий",
    markRead: "Пометить все как прочитанные",
    read_timings: "Дать доступ к отчетности",
    productCode: "Код продукта",
    eanCode: "EAN-код",
    shops: "Магазины",
    shop: "Магазин",
    addShop: "Добавить магазин",
    sellers: "Продавцы",
    seller: "Продавец",
    addSeller: "Добавить продавца",
    addProduct: "Добавить товар",
    connection: "Связь",
    rentPlatform: "Арендовать платформу",
    contactPerson: "Контактное лицо",
    contactPersonSubtitle: "Данное лицо будет первым пользователем и администратором системы",
    subdomain: "Поддомен",
    lastLogin: "Последний вход",
    products: "Товары",
    addBusinessCard: "Добавить визитку",
    frontPhoto: "Передняя сторона",
    backPhoto: "Задняя сторона",
    todoComment: "Комментарий будет добавлен в объект",
    addTask: "Добавить задачу",
    workerLimit: "Максимум работников",
    functions: "Функции",
    paid_until: "Оплачено до",
    domain: "Домен",
    onTrial: "Пробный период",
    choose: "Выбрать",
    chooseTariff: "Выберите тариф",
    chosen: "Выбрано",
    rentInfo: "Информация об аренде",
    createdDateTenant: "Дата регистрации",
    tariffPlan: "Тариф",
    changeTariff: "Сменить тариф",
    pay_platform: "Чтобы продолжить пользоваться платформой оплатите счет",
    archiveable: "Архивировать через 7 дней",
    success: "Оплата прошла упешно",
    error: "Ошибка оплаты",
    contactAdmin: "Свяжитесь с администратором",
    stripe: "Код товара Stripe",
    pay: "Оплатить",
    uploadedFiles: "Загруженные файлы",
    safePassword: "Пароль для сейфа",
    updatePassword: "Обновить пароль",
    invalidPassword: "Неверный пароль",
    safeAlert: "Не рекомендуем хранить здесь пароли и другую важную информацию.\n За сохранность данных в сейфе администрация сайта ответственности не несет",
    dateTimings: "Даты отчетов",
    withArch: "Учитывать архивные",
    copy: "Копировать",
    timingChanges: "Изменения часовых отчетов",
    checkIn: "Отметиться на объекте",
    checkOut: "Завершить работу",
    workerOnObject: "На объекте с ",
    showGeo: "Показать геолокацию",
    endWithoutReport: "Завершить без отчета",
    translate: "Перевести",
    showOriginal: "Показать оригинал",
    repeat: "Повторение",
    once: "Один раз",
    weekly: "Еженедельно",
    monthly: "Ежемесячно",
    yearly: "Ежегодно",
    until: "До",
    showHistory: "Показать историю",
    contactsVisible: "Сделать контакты видимыми",
    geoError: "Ошибка геолокации",
    workerLimitError: "Превышено допустимое количество работников в системе",
    changeDate: "Перенести на другую дату",
    downloadAllFiles: "Скачать все файлы",
    addSignature: "Отсканировать подпись",
    signature: "Подпись",
    permissionError: "Доступ запрещен",
    methodNotAllowedError: "Метод не разрешен",
    unexpectedError: "Непредвиденная ошибка",
    userExists: "Пользователь уже существует",
    tripTime: "Время поездки",

    dgantt: {
        'title': 'Диаграмма',
        'tasks': 'Задачи',
        'workType': 'Тип работ',
    },
    "months": {
        "Jan": "Январь",
        "Feb": "Февраль",
        "Mar": "Март",
        "Apr": "Апрель",
        "May": "Май",
        "Jun": "Июнь",
        "Jul": "Июль",
        "Aug": "Август",
        "Sep": "Сенябрь",
        "Oct": "Октябрь",
        "Nov": "Ноябрь",
        "Dec": "Декабрь"
    },
    "days": {
        "Mon": "Пн",
        "Tue": "Вт",
        "Wed": "Ср",
        "Thu": "Чт",
        "Fri": "Пт",
        "Sat": "Сб",
        "Sun": "Вс"
    },

    "days_genitive": 'дней',
    "filter": 'Фильтр',
    expiredDocuments: "Просроченные документы",
    upcomingAbsence: "Предстоящие отпуска",
    'selectedSection': 'Выбранный раздел',

    'holiday-work': 'Работа на выходных',
    organizationCar: "Машина организации",
    personal: "Личные",
    fromOrganization: "Организации",
    maybe: "Возможно, вы имели в виду",
    partners: "Партнеры",
    fromNotes: "Из записной книжки",
    invitations: "Приглашения",
    from: "От",
    accept: "Принять",
    reject: "Отклонить",
    find: "Найти",
    contractor: "Подрядчик",
    orgEmail: "Email организации",
    profileExist: "Есть ли у вас зарегистрированный профиль?",
    vat: "VAT",
    discountCards: "Скидочные карты",
    dueTo: "Действует до",
    workingDays: "Режим работы",
    chosenHolidays: "Выбранные праздники",
    usedLanguages: "Используемые языки",
    cv: "CV",
    loadFromProfile: "Загрузить из профиля",
    addressResidence: "Адрес проживания",
    region: "Область",
    experience: "Опыт работы",
    startDate: "Дата начала",
    addExperience: "Добавить опыт работы",
    education: "Образование",
    educationalInstitution: "Образовательное учреждение",
    startYear: "Год начала",
    endYear: "Год окончания",
    educationSphere: "Сфера образования",
    education_level: "Уровень образования",
    educationLevel: {
        "general": "Основное",
        "middle": "Среднее",
        "technical": "Профессионально-техническое",
        "high": "Высшее",
        "diploma": "Диплом",
        "bachelor": "Бакалавр",
        "master": "Магистр",
        "doctor": "Доктор"
    },
    educationHighLevel: "Полученное образование",
    licenses: "Лицензии и сертификаты",
    language: "Язык",
    languageLevel: "Уровень знаний",
    languageLevels: {
        "A1": "A1 - низкий",
        "A2": "A2 - базовый",
        "B1": "B1 - средний",
        "B2": "B2 - хороший",
        "C1": "C1 - очень хороший",
        "C2": "C2 - совершенный или родной язык",
    },
    numberOrUrl: "Номер лицензии или URL-адрес",
    issued: "Выдан (кем?)",
    year: "Год",
    portfolio: "Портфель работ",
    current: "Текущие",
    "saveAndClose": "Сохранить и закрыть",
    "profile": {
        "works_at": "Работает в"
    },
    "offerResume": "Предложить резюме",
    upload: "Загрузить",
    addressVacancy: "Адрес вакансии",
    "cvs": {
        "personalData": "Личные данные",
        "about": "О вас",
        "aboutMe": "Обо мне",
        "invite": "Пригласить",
        "location": "Местоположение",
        "residence_city": "Город проживания",
        "residence_country": "Страна проживания",
        "residence_region": "Регион проживания",
        "status": "Статус",
        "statuses": {
            "none": "не важно",
            "busy": "занят",
            "free": "свободен",
            "busy_additional": "готов взять дополнительную работу"
        },
        "skills": "Навыки",
        "contacts": "Контакты",
        "radius": "Радиус поиска",
        "residence_address": "Адрес проживания",
        "issued": "Выдан"
    },
    "hh": {
        "CV": "Резюме",
        "active": "Активная вакансия",
        "additionalInfo": "Дополнительная информация",
        "address": "Адрес",
        "approve": "Одобрить",
        "city": "Город",
        "company": "Компания",
        "contact_person": "Контактное лицо",
        "country": "Страна",
        "cover_letter": "Сопроводительное письмо",
        "decline": "Отклонить",
        "description": "Описание",
        "details": "Детали",
        "firstname": "Имя",
        "has_approved_organization_by_organization": "Вы согласились принять кандидата на работу",
        "has_approved_organization_by_worker": "Вас согласились принять на работу",
        "has_approved_worker_by_company": "Кандидат согласен выйти на работу",
        "has_approved_worker_by_worker": "Вы согласны выйти на работу",
        "has_declined_organization_by_organization": "Вы отклонили резюме",
        "has_declined_organization_by_worker": "Вашу кадидатуру отклонила компания",
        "has_declined_worker_by_company": "Кандидат отконил Вашу вакансию",
        "has_declined_worker_by_worker": "Вы отклонили вакансию",
        "has_not_approved_organization_by_worker": "Компания еще рассматривает ваше резюме",
        "has_not_approved_worker_by_company": "Кандидат еще не принял решение",
        "highlights": "Основная информация",
        "lastname": "Фамилия",
        "location": "Местоположение",
        "mainInfo": "Основная информация",
        "noCv": "Нет резюме",
        "noVacancy": "Нет вакансии",
        "offer": "Предложение",
        "position": "Должность",
        "region": "Регион",
        "remote": "Удаленная работа",
        "respond": "Ответить",
        "salary": "Зарплата",
        "skills": "Требуемые навыки",
        "type": "Тип занятости",
        "vacancy": "Вакансия",
        "worker": "Сотрудник",
        "fulltime": "Полная",
        "parttime": "Частичная",
        "temporary": "Временная работа",
        "contract": "Сдельная работа",
        "seasonal": "Сезонная работа",
        "volunteer": "Волонтерство",
        "responsibilities": "Обязанности",
        "documents": "Неободимые документы",
        "useful": "Полезным будет",
        "salaryType": "Тип зарплаты",
        "currency": "Валюта",
        "netto": "на руки",
        "brutto": "до вычета налога",
        "conditions": "Условия",
        "need_experience": "Требуется опыт",
        "experience": "Опыт",
        "not_remote": "Нет",
        "vacancy_address": "Адрес вакансии",
        "responded": "Вы уже откликнулись",
        "responded_work": "Вы уже работаете здесь",
        "declined": "Заявка отклонена",
        "approved_for_worker": "Вы приняты на работу",
        "approved_for_organization": "Работник принят на работу. Необходимо назначить ему права",
        "search": "Поиск по должности и навыкам"
    },
    "min": "Минимум",
    "max": "Максимум",
    "open": "Открыть",
    "editedLanguages": "Редактируемые языки",
    "chat": "Чат",
    "dismiss": "Уволить",
    "dismissed": "Уволенные",
    "hire": "Нанять",
    "maintenanceReports": "Отчеты по ТО/ремонту",
    "worksAndMaterials": "Работы и материалы",
    "receipt": "Чек",
    "maintenanceType": "Тип ТО/ремонта",
    "material": "Материал",
    "work": "Работа",
    "otherType": "Другое",
    "code": "Код",
    "nextServiceDate": "Дата следующего ТО",
    "codeMaterial": "Код товара",
    "codeWork": "Код работы",
    "km": "км",
    "editNews": "Редактировать новость",
    "undo": "Отменить действие",
    "redo": "Повторить действие",
    "Bold": "Жирный",
    "Italic": "Курсив",
    "Link": "Ссылка",
    "AlignLeft": "Выровнять по левому краю",
    "AlignCenter": "Выровнять по центру",
    "AlignRight": "Выровнять по правому краю",
    "OrderedList": "Нумерованный список",
    "UnorderedList": "Маркированный список",
    "InsertImage": "Вставить изображение",
    "ClearFormatting": "Очистить форматирование",
    "Heading1": "Заголовок 1",
    "Heading2": "Заголовок 2",
    "Heading3": "Заголовок 3",
    "InsertTable": "Вставить таблицу",
    "TableBorders": "Границы таблицы",
    "TextColor": "Цвет текста",
    "EnterHyperlink": "Введите гиперссылку",
    "rows": "Строки",
    "columns": "Столбцы",
    "MinValueError": "Пожалуйста, укажите количество строк и столбцов (минимум 1)",
    "brutto": "Брутто",
};
//# sourceMappingURL=ru.js.map
